export default __webpack_public_path__ + "static/media/Illustrasjoner10.aa099564.svg";